<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <a
            id="junior-pilot-request-sub-header-back"
            class="l-top-navi__back-link"
            [routerLink]="backUrl"
            (click)="back()"
          >
            <span class="u-visually-hidden" innerHTML="{{ 'reader.goBackToPreviousPage' | staticMsg }}"></span>
          </a>
        </div>
        <div class="l-top-navi__heading-area top-navi-junior-pilot-request">
          <h1 class="l-top-navi__heading-text" innerHTML="{{ 'heading.unaccompaniedMinor' | staticMsg }}"></h1>
          <asw-tooltip
            iconImage="<img src=&quot;{{ appConstants.IMG.ICON_HELP }}&quot; alt=&quot;{{
              'alt.helpIcon2' | staticMsg
            }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
            tooltipContent="{{ 'tooltip.juniorPilot' | staticMsg }}"
            [tooltipTop]="-85"
          >
          </asw-tooltip>
        </div>
      </div>
    </div>
  </div>
</div>
